import { produce } from 'immer'
import { State } from '../typings'
import { LocationMatch } from '@user/store/entityLocations'

export type MatchServiceAction = {
  type: 'matchService'
  payload: LocationMatch
}

export const matchService = produce<State, [MatchServiceAction['payload']]>(
  (draft, payload) => {
    draft.matches.set(payload.locationId, payload)
  },
)
